/**
 * 表单通用 mixins
 */

export default {
  data() {
    return {
    };
  },
  methods: {
    // 表单校验成功之后的回调（子类进行复写）
    submitHandle() {},

    // 点击提交（开始表单校验）
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitHandle(formName);
        }
      });
    },

    // 清除表单验证
    clearValidate(formName) {
      this.$refs[formName].clearValidate();
    },

    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
